import { render, staticRenderFns } from "./AuthDialog.vue?vue&type=template&id=4f8da7b8&scoped=true"
import script from "./AuthDialog.vue?vue&type=script&lang=js"
export * from "./AuthDialog.vue?vue&type=script&lang=js"
import style0 from "./AuthDialog.vue?vue&type=style&index=0&id=4f8da7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8da7b8",
  null
  
)

export default component.exports